import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const getAllPermissions = async () => {
  const response = await API.get(APIEndpoints.GET_ALL_PERMISSIONS_FOR_APP_CODE);
  return response.data;
};

export const allPermissionsAPI = {
  getAllPermissions,
};
